// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticlesListModel from '../../model/shop-articles-list-model';
import ShopArticlesListDTO from '../dto/shop-articles-list-dto';
import dtoSchema from '../schemas/shop-articles-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopArticlesListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticlesListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.articleNumber = data.articleNumber ?? undefined;
      this.caption = data.caption ?? undefined;
      this.description = data.description ?? undefined;
      this.shortDescription = data.shortDescription ?? undefined;
      this.mainPictureId = data.mainPictureId;
      this.validFrom = data.validFrom;
      this.validTo = data.validTo ?? undefined;
      this.shopArticleTaxId = data.shopArticleTaxId;
      this.isPublished = data.isPublished;
      this.language_ISO2 = data.language_ISO2 ?? undefined;
      this.unitGrossPrice = data.unitGrossPrice;
      this.unitNetPrice = data.unitNetPrice;
      this.taxAmount = data.taxAmount;
      this.taxRate = data.taxRate;
      this.taxName = data.taxName ?? undefined;
      this.taxShortName = data.taxShortName ?? undefined;
      this.hasLicense = data.hasLicense;
      this.isDownload = data.isDownload;
      this.digitalAssetId = data.digitalAssetId ?? undefined;
      this.hasShipping = data.hasShipping;
      this.categoryId = data.categoryId;
      this.sortIndex = data.sortIndex;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  articleNumber?: string;
  /**
  */
  caption?: string;
  /**
  */
  description?: string;
  /**
  */
  shortDescription?: string;
  /**
  * @type {int64}
  */
  mainPictureId?: number;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validTo?: string;
  /**
  * @type {double}
  */
  shopArticleTaxId?: number;
  /**
  */
  isPublished?: boolean;
  /**
  */
  language_ISO2?: string;
  /**
  * @type {double}
  */
  unitGrossPrice?: number;
  /**
  * @type {double}
  */
  unitNetPrice?: number;
  /**
  * @type {double}
  */
  taxAmount?: number;
  /**
  * @type {double}
  */
  taxRate?: number;
  /**
  */
  taxName?: string;
  /**
  */
  taxShortName?: string;
  /**
  */
  hasLicense?: boolean;
  /**
  */
  isDownload?: boolean;
  /**
  * @type {int64}
  */
  digitalAssetId?: number;
  /**
  */
  hasShipping?: boolean;
  /**
  * @type {int64}
  */
  categoryId?: number;
  /**
  * @type {int32}
  */
  sortIndex?: number;

  static toModel(dto: DeepPartial<ShopArticlesListDTO>): ShopArticlesListModel;
  static toModel(dto: DeepPartial<ShopArticlesListDTO> | undefined | null): ShopArticlesListModel | undefined;
  static toModel(dto: DeepPartial<ShopArticlesListDTO> | undefined | null): ShopArticlesListModel | undefined {
    return dto ? new ShopArticlesListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticlesListModel> | ShopArticlesListModel): ShopArticlesListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      articleNumber: unwrapped.articleNumber,
      caption: unwrapped.caption,
      description: unwrapped.description,
      shortDescription: unwrapped.shortDescription,
      mainPictureId: unwrapped.mainPictureId,
      validFrom: unwrapped.validFrom,
      validTo: unwrapped.validTo,
      shopArticleTaxId: unwrapped.shopArticleTaxId,
      isPublished: unwrapped.isPublished,
      language_ISO2: unwrapped.language_ISO2,
      unitGrossPrice: unwrapped.unitGrossPrice,
      unitNetPrice: unwrapped.unitNetPrice,
      taxAmount: unwrapped.taxAmount,
      taxRate: unwrapped.taxRate,
      taxName: unwrapped.taxName,
      taxShortName: unwrapped.taxShortName,
      hasLicense: unwrapped.hasLicense,
      isDownload: unwrapped.isDownload,
      digitalAssetId: unwrapped.digitalAssetId,
      hasShipping: unwrapped.hasShipping,
      categoryId: unwrapped.categoryId,
      sortIndex: unwrapped.sortIndex,
    } as ShopArticlesListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticlesListModel, can not map to ShopArticlesListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
